var ismobile = false;

var responsive = false;

if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
	ismobile = true;
}

$(document).ready(function(){

	

	function googlemaps(sel, fadeout){

		var $this = sel;

		var latitude = parseFloat($this.data('latitude'));
		var longitude = parseFloat($this.data('longitude'));

		if( latitude && latitude > 0 && longitude && longitude > 0 ){

			//if(!$('#gmap').is(':visible')){

			if($('#gmap').length == 0){

				$('#wrapper').append('<div id="gmap"></div>');

				var top = $this.offset().top + $this.height() + 20;

				var documentHeight = $(document).height();

				var calcHeight = top + $('#gmap').height();
			

				if($('#wrapper').hasClass('wrapper-small')){

					top = top + 60;

				}


				if(calcHeight > documentHeight - 150 && responsive == false){

					top = $this.offset().top - $('#gmap').height() - $this.height() - 40;

				}


				$('#gmap').css('top', top + 'px').fadeIn();


				if($('#gmap').html().length == 0){
                  
                  var map = new ol.Map({
                    target: 'gmap',
                    layers: [
                      new ol.layer.Tile({
                        source: new ol.source.OSM()
                      })
                    ],
                    view: new ol.View({
                      center: ol.proj.fromLonLat([longitude, latitude]),
                      zoom: 15
                    })
                  });
                  console.log(map);

					/*new Maplace({
					    map_div: '#gmap',
					    locations: [{
					        lat: latitude, 
					        lon: longitude,
					        zoom: 0
					    }],
					    start: 1,
					    map_options: {
					        zoom: 15
					    },
					    styles: {
					        'Night': [{
					            featureType: 'all',
					            stylers: [
					                { invert_lightness: 'true' }
					            ]
					        }],
					        'Greyscale': [{              
					            featureType: 'all',
					            stylers: [
					                { saturation: -100 },
					                { gamma: 0.50 }
					            ]
					        }]
					    }
					}).Load();*/

				}


				if(calcHeight > documentHeight - 200 && responsive == false){

					$('#gmap').append('<div id="gmap-shadow-rev"></div>').css('margin-bottom');

				}else{

					$('#gmap').append('<div id="gmap-shadow"></div>').css('margin-top', '10px');

				}


			}else{
				if(fadeout && fadeout == true){
					$('#gmap').fadeOut(400, function(){
						$('#gmap').remove();
					});
				}

			}

		}

		return false;


	}
/*simply call googlemaps($('.btn-googlemaps'),true)*/
	$('.btn-googlemaps').click(function(){
		googlemaps($(this), true);
	});



	$('html, body, #wrapper').on('click', function (e){

	    var container1 = $(".btn-googlemaps");
	    var container2 = $('#gmap');

	    if (!container1.is(e.target) && container1.has(e.target).length === 0
	    	&& !container2.is(e.target) && container2.has(e.target).length === 0){
	        $('#gmap').fadeOut(400, function(){
	        	$('#gmap').remove();
	        });
	    }

	});	


	
	if(ismobile == false){

		$('.btn-googlemaps').on('mouseenter', function(){
			if(responsive == false){
				googlemaps($(this));
			}
		});

	}



	$(window).on('resize.googlemaps', function(){

		$('#gmap').hide().remove();

	});

	/*
	$(document).on('scroll.googlemaps', function(){

		if($('#wrapper').hasClass('wrapper-small')){

			$('#gmap').addClass('gmap-up');

		}else{
			$('#gmap').removeClass('gmap-up');
		}

	});*/



});